<template>
  <div class="machines-index d-flex flex-column">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="machines"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
      :refresh.sync="refresh"
    ></filtered-data>

    <div class="container-fluid">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">
          Автоматы
        </h1>
        <machine-list-map-tabs v-if="data"></machine-list-map-tabs>
        <button class="btn btn-primary mx-2" @click="openModal()" v-if="$root.checkPermission('web_ta_edit')">Добавить автомат</button>
        <btn-filters

          :data="data"
          endpoint="machines"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>
    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
        @load-more="loadMore"
      >
        <table-column-serial-number sortable="keyword" :fixed="true"/>
        <el-table-column prop="modem.uid" label="" width="30" v-if="$root.checkPermission('web_modems')">
          <template slot-scope="{row}">
            <tooltip v-if="row.modem" :title="`${row.modem.uid}`">
              <router-link :to="`/modems/${row.modem.uid}`" class="text-body">
                <font-awesome-icon icon="wifi"/>
              </router-link>
            </tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="Состояние" width="180">
          <template slot-scope="{row}">
            <status-images :value="row.status"></status-images>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="modem.netinterface" sortable="keyword" label="Связь" min-width="130">
          <template slot-scope="{row}">
            <div v-if="row.modem" :class="row.is_online ? '' : 'text-danger'">
              {{ row.is_online ? row.modem.netinterface : 'Нет' }}
            </div>
            <div v-else>модем не подключен</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="modem.data.operator" sortable="custom" label="Оператор" align="left" min-width="105">
          <template slot-scope="{row}">
            <div v-if="row.modem && row.modem.data">
              {{ row.modem.data.operator ? row.modem.data.operator.replace(/["*]/g, '') : "Нет данных" }} ({{ row.modem.data.signal ? row.modem.data.signal : "?%"}})
            </div>
            <div v-else>Нет модема</div>
          </template>
        </el-table-column>
        <el-table-column prop="modem.door_closed" sortable="custom" label="Дверь" min-width="90">
          <template slot-scope="{row}">
            <div v-if="row.modem"
              :class="(row.modem.door_closed ? row.is_online : !row.is_online) ? 'text-success' : 'text-danger'">
              {{ row.modem.door_closed ? 'Закрыта' : 'Открыта' }}
            </div>
            <div v-else>Нет модема</div>
          </template>
        </el-table-column>
        <el-table-column prop="modem.electricity" sortable="custom" label="Питание" min-width="100">
          <template slot-scope="{row}">
            <div v-if="row.modem" :class="row.modem.electricity ? '' : 'text-danger' ">
              {{ row.modem.electricity ? 'Норма' : 'Ошибка' }}
            </div>
            <div v-else>Нет модема</div>
          </template>
        </el-table-column>
        <table-column-date
          prop="downtimes_since.sales"
          label="Без продаж"
          min-width="120"
          width=""
          :from-now="true"
          :from-now-remove-suffix="true"
          sortable="last_sale_at"
        />
        <el-table-column prop="model.name" sortable="keyword" label="Модель" min-width="170"/>
        <el-table-column prop="address" sortable="keyword" label="Адрес" :show-overflow-tooltip="true" min-width="260"/>
        <el-table-column prop="modem.battery" sortable="custom" label="Батарея" align="center" min-width="105">
          <template slot-scope="{row}">
            <div v-if="row.modem">
              <div v-if="row.modem.battery !== null" :class="row.modem.battery < 40 ? 'text-danger' : ''">
                {{ row.modem.battery}} %
              </div>
              <div v-else>Нет данных</div>
            </div>
            <div v-else>Нет модема</div>
          </template>
        </el-table-column>
        <table-column-number prop="coins_sum" sortable="custom" label="Монеты" align="center" min-width="100"/>
        <table-column-number prop="banknotes_sum" sortable="custom" label="Купюры" align="center" min-width="100"/>
        <el-table-column align="center" width="100">
          <template slot-scope="{row}">
            <button class="btn btn-sm btn-outline-light" @click="copyMachine(row.id)">
              Копировать
            </button>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import Tooltip from '../../components/tooltip'
  import machineModal from '../../components/machines/modals/machine-modal.vue'
  import api from '@/api'

  export default {
    components: {Tooltip},
    metaInfo: {title: 'Автоматы'},
    data () {
      return {
        filtersValue: null,
        data: null,
        loading: false,
        hasMore: true,
        sort: null,
        refresh: false,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const sortable = sort.column.sortable
          const prop = sortable === 'keyword'
            ? sort.prop + '.keyword'
            : sortable === 'custom' ? sort.prop : sortable
          this.sort = `${prop}:${order}`
        } else {
          this.sort = null
        }
      },
      loadMore () {
        this.$refs.data.loadMore()
      },
      openModal (data) {
        this.$root.showModal(machineModal, data)
          .then((data) => {
            if (data) {
              this.refresh = true
            }
          })
      },
      copyMachine (machineId) {
        api.get('machines/' + machineId)
          .then(({data}) => {
            this.openModal({machine: data.data, copy: true})
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/machines/index.vue